import { render, staticRenderFns } from "./photo-nerve.vue?vue&type=template&id=0b2f1b31&scoped=true&"
import script from "./photo-nerve.vue?vue&type=script&lang=js&"
export * from "./photo-nerve.vue?vue&type=script&lang=js&"
import style0 from "./photo-nerve.vue?vue&type=style&index=0&id=0b2f1b31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2f1b31",
  null
  
)

export default component.exports